/**
 * Le raccourci « Ajouter à Mijoté » (US-72), et son lien d'installation (US-106).
 *
 * **Pourquoi une URL en dur dans le code.** C'est un réglage d'instance, pas
 * une constante de produit : le lien iCloud est produit par l'iPhone de
 * quelqu'un, il nomme *ce* raccourci-là, et une autre instance en aurait un
 * autre. Sa place « juste » serait `instance_setting` (US-69), avec un champ
 * dans les réglages pour le poser.
 *
 * Il n'y est pas, et c'est une décision plutôt qu'un oubli : ce serait une
 * migration, une route, un champ et un écran pour une valeur qui change tous
 * les jamais, dans une application qui tourne sur **une** instance. Le §5 de
 * `CLAUDE.md` le dit dans ces termes — « pas d'abstraction anticipée … le code
 * doit rester lisible, pas extensible ». Le jour où une deuxième instance
 * existe, la valeur déménage ; d'ici là, elle est ici, à un seul endroit, et
 * ce commentaire dit comment la changer.
 *
 * **Pour la remplacer :** dans l'app Raccourcis de l'iPhone, « Partager » sur
 * le raccourci produit un nouveau lien iCloud. Coller ici, et c'est tout.
 *
 * **Ce que le lien ne porte pas, et ne portera jamais : le jeton.** Il nomme
 * une personne et remplit *son* sas. Chacun colle le sien après installation,
 * depuis Réglages › Depuis mon téléphone. Un lien qui porterait un jeton
 * donnerait à toute la maison le droit d'écrire dans le sas d'une seule
 * personne — et il serait recopié dans un fil de discussion familial avant la
 * fin de la journée.
 */
export const LIEN_RACCOURCI_IOS = 'https://www.icloud.com/shortcuts/df92479e1d834c86a377848fdae043b9';

/** Cet appareil peut-il installer le raccourci ? iOS et iPadOS seulement. */
export function estUnAppareilApple(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = window.navigator.userAgent;
  // Un iPad récent s'annonce comme un Mac ; le point tactile le trahit, et
  // c'est le seul moyen sans API dédiée. Un Mac tactile n'existe pas.
  const iPadModerne = /Macintosh/.test(ua) && window.navigator.maxTouchPoints > 1;
  return /iPad|iPhone|iPod/.test(ua) || iPadModerne;
}
